import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Richins
 * id 9426C325-5C35-40D8-9CA4-DA230CCC2736
 * name toy-brick-plus
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/toy-brick-plus.svg
 * tags
 */
export const ToyBrickPlusIcon = createSvgIcon(<><path d="M19 6V5A2 2 0 0 0 17 3H15A2 2 0 0 0 13 5V6H11V5A2 2 0 0 0 9 3H7A2 2 0 0 0 5 5V6H3V20H13.09A5.47 5.47 0 0 1 13 19A6 6 0 0 1 21 13.34V6M20 15V18H23V20H20V23H18V20H15V18H18V15Z" /></>, 'ToyBrickPlusIcon');
export default ToyBrickPlusIcon